import { render, staticRenderFns } from "./ModalWrapper.vue?vue&type=template&id=1fd8316e&scoped=true&lang=pug&"
import script from "./ModalWrapper.vue?vue&type=script&lang=ts&"
export * from "./ModalWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./ModalWrapper.vue?vue&type=style&index=0&id=1fd8316e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd8316e",
  null
  
)

export default component.exports